import { Icon } from '@ui/themed';
import { formatMoney } from '../../../../../utils/format-money';
import { Bar } from '../../../shared/components/bar';
import { GraphicFrame } from '../../../shared/components/graphic-frame';
import { PlantGraphic } from '../../../shared/components/plant-graphic';

// A round example store price so the derived B2B price in the preview reads cleanly.
const EXAMPLE_STORE_PRICE = 100;

// Storefront preview for the price-list step: the discount applied to an example product. The store
// price is illustrative; the discount is real (from the price list).
export function PriceGraphic({
  currencyCode,
  discountPercent,
}: {
  currencyCode: string;
  discountPercent: number;
}) {
  const b2bPrice = EXAMPLE_STORE_PRICE * (1 - discountPercent / 100);

  return (
    <GraphicFrame>
      <div className="flex h-full flex-col justify-center gap-4 px-4 py-4">
        <div className="flex items-center gap-3.5">
          <div className="grid size-15 shrink-0 place-items-center rounded-xl bg-gray-100">
            <PlantGraphic className="h-11 w-auto" />
          </div>
          <div className="min-w-0 flex-1">
            <Bar className="h-2 w-12" />
            <div className="mt-2.5 flex flex-row flex-nowrap items-baseline gap-2">
              <span className="font-bold text-[26px] text-gray-900 leading-none tracking-tight">
                {formatMoney(b2bPrice, currencyCode)}
              </span>
              <span className="text-gray-400 text-sm line-through">
                {formatMoney(EXAMPLE_STORE_PRICE, currencyCode)}
              </span>
            </div>
          </div>
        </div>

        <div className="flex items-stretch gap-2.5">
          <div className="flex h-9 items-center overflow-hidden rounded-xl border border-gray-200 text-gray-900">
            <span className="grid w-7 place-items-center text-gray-400 text-lg">−</span>
            <span className="w-5 text-center font-semibold text-[13px]">1</span>
            <span className="grid w-7 place-items-center text-gray-400 text-lg">+</span>
          </div>
          <div className="flex h-9 flex-1 items-center gap-2 rounded-full bg-platform-primary px-3.5 text-white shadow-lg">
            <Icon name="cart" size="sm" />
            <Bar tone="onPrimary" className="h-2 flex-1" />
          </div>
        </div>
      </div>
    </GraphicFrame>
  );
}
